import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

import { BC } from '../../types/index.js'

import { CollectionsLoading } from './CollectionLoading.js'
import { CollectionMenuCollapsible } from './CollectionMenuCollapsible.js'
import { CollectionMenuHeading } from './CollectionMenuHeading.js'
import { CollectionMenuSimple } from './CollectionMenuSimple.js'
import {
  CollectionMenuProps,
  CollectionMenuSpaceFilter,
  CollectionMenuViewStyle,
} from './types.js'
import { useCollectionMenuEntries } from './useCollectionMenuEntries.js'
import { getOrderedCollections } from './utils.js'

export const CollectionMenuBlock: BC<CollectionMenuProps> = ({
  items,
  viewStyle,
  spaceFilter = CollectionMenuSpaceFilter.All,
  ...rest
}) => {
  const { data: network = {} } = useNetwork()
  const [canCreateSpace] = hasScopesPermission(network, ['addSpace'])

  const { entries, isLoading, isReady } = useCollectionMenuEntries({
    items,
    viewStyle,
    spaceFilter,
  })

  if (!isReady || isLoading) {
    return <CollectionsLoading />
  }

  const orderedCollections = getOrderedCollections(items ?? [], entries)

  if (viewStyle === CollectionMenuViewStyle.Simple) {
    return <CollectionMenuSimple collections={orderedCollections} {...rest} />
  }
  if (viewStyle === CollectionMenuViewStyle.Collapsible) {
    return (
      <CollectionMenuCollapsible
        canCreateSpace={canCreateSpace}
        collections={orderedCollections}
        {...rest}
      />
    )
  }
  if (viewStyle === CollectionMenuViewStyle.Heading) {
    return (
      <CollectionMenuHeading
        canCreateSpace={canCreateSpace}
        collections={orderedCollections}
        {...rest}
      />
    )
  }
  return null
}
